const IdeaIcon = ({ width = 24, height = 24, customClass = '', withoutBorder = false }) => (
  <svg width={width} height={height} class={customClass} viewBox={withoutBorder ? '2 2 20 20' : '0 0 24 24'} xmlns='http://www.w3.org/2000/svg'>
    <path d='M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2Z' fill='currentColor' />
  </svg>
)

export default IdeaIcon
